import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class AlertService {
    private readonly getAlertURL = `/inventory-alerts`;
    // ---------------------------------------------------------------

    getAlert(params: { size: number; page: number; productId: string }) {
        return fetchWithRetry(API.get(this.getAlertURL, { params }));
    }
}

export default new AlertService();
